import { MB_RATIO } from '@app/components/DraggerComponent/data/constants';

export const extensions = [
  'jpeg',
  'jpg',
  'png',
  'doc',
  'docx',
  'pdf',
  'xls',
  'xlsx',
  'txt',
  'mp4',
  'webp',
];

export const MAX_FILES_SIZE_SENDOUT_MB = 300;
export const MAX_FILES_SIZE_SENDOUT = MAX_FILES_SIZE_SENDOUT_MB * MB_RATIO;
